import { baseApi } from "./baseApi";

export const reportsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    createListingReport: builder.mutation<unknown, Record<string, unknown>>({
      query: (payload) => ({ url: "/reports", method: "POST", data: payload }),
      invalidatesTags: [{ type: "Reports", id: "LIST" }],
    }),
    createUserReport: builder.mutation<unknown, Record<string, unknown>>({
      query: (payload) => ({ url: "/users/report", method: "POST", data: payload }),
      invalidatesTags: [{ type: "Reports", id: "LIST" }],
    }),
  }),
});

export const { useCreateListingReportMutation, useCreateUserReportMutation } = reportsApi;
